<template>

    <div>
        <WaitingPrice
            :entity-type="BUSINESS_TYPE.PHARMACY"
            :entity-id="+$route.params.id"
        >
            <template v-slot:tabs>
                <PharmacyTabLinks />
            </template>
        </WaitingPrice>
    </div>

</template>

<script>
    import PharmacyTabLinks from '@/components/pharmacies/PharmacyTabLinks';
    import WaitingPrice from '@/components/waiting-price/WaitingPrice';
    import { BUSINESS_TYPE } from '@/utils/order';

    export default {

        name: 'EntityWaitingPrice',

        components: {
            PharmacyTabLinks,
            WaitingPrice
        },
  
        data () {
            return {
                BUSINESS_TYPE,
                entity: {}
            }
        },
    
        computed: {},

        async mounted() {
        },

        methods: {}
    }
</script>
